import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/help/')({
  component: () => <div>Hello /_layout/dashboard/help/!</div>,
})
